export enum PaymentGatewayEnum {
  JUSPAY = 'juspay',
  INDUSTRYBUYING = 'industrybuying',
  RAZORPAY = 'razorpay',
}
